<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`提交报告`"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="报告编号">
            <el-input disabled :value="activeInfo.reportCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测项目">
            <el-input disabled :value="activeInfo.sampleName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="审核人" prop="auditedBy">
            <el-select v-model="editForm.auditedBy" filterable>
              <el-option v-for="item in auditByOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { submitFlowDeliverAuth } from '@/api/flow';
import { getUserListByCode } from '@/api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {
        auditedBy: ''
      },
      auditByOptions: [],
      rules: {
        auditedBy: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeInfo.id) {
        this.getUserOptions();
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          try {
            await submitFlowDeliverAuth({
              id: this.activeInfo.id,
              auditedBy: this.editForm.auditedBy
            });

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    async getUserOptions() {
      const { data } = await getUserListByCode({ roleCode: 'SHY' });
      this.auditByOptions = data?.list || [];
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
